import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody, CardFooter } from "../Card"
import ToggleSwitch from '../ToggleSwitch'
import Category from '../Category'
import actions from '../../actions/index'
import { currentUtcDateTime } from '../../utils/dateTime'
import { pushContentToMatomo } from '../../utils/matomo'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

class GeneralPaddle extends Component {
  constructor(props) {
    super(props);

    this.state = { checked: this.props.defaultChecked }
  }

  callSubmit = (updatedAlertPreference) => {
    const request = () => {
      return {
        ...this.props.preferences,
        alertPreferences: updatedAlertPreference
      }
    }

    this.props.onSubmit(request())
  }

  saveInstantAlertPreference = (currentInstantAlert) => {
    let newAlertPreferences = this.props.preferences.alertPreferences.map(element => element.id == this.props.id ? { ...element, instantAlert: currentInstantAlert, dateModified: currentUtcDateTime() } : element);

    // this.props.alertPreference.instantAlert = currentInstantAlert

    this.callSubmit(newAlertPreferences)
  }

  saveDailyAlertPreference = (currentDailyAlert) => {
    let newAlertPreferences = this.props.preferences.alertPreferences.map(element => element.id == this.props.id ? { ...element, dailyWrapUpAlert: currentDailyAlert, dateModified: currentUtcDateTime() } : element);

    // this.props.alertPreference.dailyWrapUpAlert = currentDailyAlert

    this.callSubmit(newAlertPreferences)
  }

  deleteContentSet = () => {
    let modifiedPreferences = this.props.preferences.alertPreferences.filter(x => x.id != this.props.id)

    this.callSubmit(modifiedPreferences)
  }

  pushToMatomo = (uiEvent, contentSetName, uiValue) => {
    var contextData = {
      "contentSetName": contentSetName
    }

    pushContentToMatomo(uiEvent,'personalize', 'custom_contentset', 'click', uiValue, contextData)
  }

  confirmDelete = (e) => {
    e.preventDefault()
    confirmAlert({
      title: 'Confirm deletion',
      message: 'Are you sure you want to delete this content set?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.deleteContentSet()

            this.pushToMatomo("contentset_delete", this.props.name, 'delete')
          }
        },
        {
          label: 'Cancel',
          onClick: () => { }
        }
      ]
    });
  };

  render() {
    let dailyWrapupText = 'Daily Wrap-up | ' + this.props.alertPreference.dailyWrapUpAlertTime + ' (GMT)'
    let instantSwitchId = `tsInstantAlert${this.props.id}`
    let dailySwitchId = `tsDailyWrapup${this.props.id}`
    let deleteButtonId = `deleteContentSet${this.props.id}`
    let editButtonId = `editContentSet${this.props.id}`
    
    return (
      <div className={'paddle general_paddle' + (this.props.alertPreference.dailyWrapUpAlert || this.props.alertPreference.instantAlert ? ' alert_enabled' : ' alert_disabled')}>
        <Card>
          <CardHeader>
            <span className='paddle_name'>{this.props.name}</span>
            <span className='instant_alert toggle_control'>
              <ToggleSwitch id={instantSwitchId} Name={instantSwitchId} defaultChecked={this.props.alertPreference.instantAlert} apiCallFunc={this.saveInstantAlertPreference} text='Instant Alert' 
              datagmupn='personalize'
              datagmuc='custom_contentset'
              datagmue='contentset_instanttoggle'
              datagmua='click'
              contentSetName={this.props.name}/>
            </span>
            <span>
              <ToggleSwitch id={dailySwitchId} Name={dailySwitchId} defaultChecked={this.props.alertPreference.dailyWrapUpAlert} apiCallFunc={this.saveDailyAlertPreference} text={dailyWrapupText} 
              datagmupn='personalize'
              datagmuc='custom_contentset'
              datagmue='contentset_dailytoggle'
              datagmua='click'
              contentSetName={this.props.name}/>
            </span>
          </CardHeader>
          <CardBody>
            <Category title="Areas of Interest" items={this.props.alertPreference.areasOfInterest} numberOfitemsShown="7" />
            <Category title="Industries" items={this.props.alertPreference.industries} numberOfitemsShown="7" />
            <Category title="Geographies" items={this.props.alertPreference.geographies} numberOfitemsShown="7" />
            <Category title="Content Types" items={this.props.alertPreference.contentTypes} numberOfitemsShown="7" />
            <Category title="Topics" items={this.props.alertPreference.topics} numberOfitemsShown="7" />           
          </CardBody>
          <CardFooter>
            <div className='right-align-button-spacer'>
              <a className='footer_button' id={deleteButtonId} onClick={this.confirmDelete}
                href='#'>
                <span className='footer_button_icon'></span>
                <span className='button_icon_text font-14'>Delete</span>
              </a>
            </div>
            <div>
              <a className='footer_button'
                href={`/#/ContentSet/${this.props.id}`} target='_self' id={editButtonId}
                onClick={() => this.pushToMatomo("contentset_edit", this.props.name, 'edit')}>
                <span className='footer_button_icon'></span>
                <span className='button_icon_text font-14'>Edit</span>
              </a>
            </div>
          </CardFooter>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    preferences: state.userPreferences
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSubmit(request) {
    dispatch(actions.updatePreferences(request))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralPaddle)
